import React, { useEffect, useMemo, useState } from 'react';
import './OfflineCoursePage.css'
import { Helmet } from 'react-helmet';
import C2wNavbar from '../../components/C2wNavbar/navbarIndex';
import C2wCourseAnimationBar from '../c2wHomePage/coursesDetails/courseAnimatiionBar/courseAnimationBar';
import C2wCourseHighLightBar from '../c2wHomePage/coursesDetails/contentHightlightBar/courseHighLightBar';
import C2wCourseDetailsCourseDescription from '../c2wHomePage/coursesDetails/courseDesription/courseDescription';
import C2wCourseProvided from '../c2wHomePage/coursesDetails/courseProvided/courseProvided';
import { Element } from 'react-scroll';
import C2wCourseDemoLectures from '../c2wHomePage/coursesDetails/courseDemoLectures/courseDemoLectures';
import C2wCourseHabits from '../c2wHomePage/coursesDetails/courseHabits/courseHabits';
import C2wCourseAssignments from '../c2wHomePage/coursesDetails/courseAssignments/courseAssignments';
import C2wCourseQuiz from '../c2wHomePage/coursesDetails/courseQuiz/courseQuiz';
import C2wCourseAnalytics from '../c2wHomePage/coursesDetails/courseAnalytics/courseAnalytics';
import C2wReviews from '../c2wHomePage/coursesDetails/reviews/reviews';
import C2wCourseCertificate from '../c2wHomePage/coursesDetails/courseCertificate/courseCertificate';
import C2wRules from '../c2wHomePage/coursesDetails/rules/rules';
import Footer from '../c2wHomePage/Footer';
import { data, useParams } from 'react-router';
import C2wCompleteSyllabus from '../c2wHomePage/coursesDetails/completeSyllabus/completeSyllabus';
import C2wProjectCarousel from './projects/projects';
import { setPopUpFlag } from '../../C2wStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import C2wAppDownloadPopUp from '../../common/C2wHome/courseDetails/C2wAppDownloadPopUp';
import C2wAppRegisterInfoPopUp from '../../common/C2wHome/courseDetails/downlaodAppPopUp';
import C2wOfflineCourseProject from './projects/projects';
import C2wScrollerFramer from './ScrollFramer/scrollerFramer';
import C22wToolChain from './toolChain/toolChain';
import C2wTopAiTools from './topAiTools/topAiTools';
import C2wToolChain from './toolChain/toolChain';
import C2wOfflineCertificates from './certificates/certificats';
import C2wQuizeethon from '../quizeethon/Quizeethon';
import C2wSuperxWinners from './superWinners/superxWinners';
import courseDetailData from '../../data/offlineCourseData.json'


function C2wOfflineCoursePage() {

  const dispatch = useDispatch()
  const [commonCourseData, setCourseCommonData] = useState(null);
  const [error, setError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [name, setName] = useState('')
  const [number, setNumber] = useState('')
  const [isValidNumber, setIsValidNumber] = useState(false)

  const { slug } = useParams()

  const generateSlug = (name) => {
    return name?.replace(/\s+/g, '-') ?? '';
  };

  // useEffect(() => {
  //   fetch("/data/offlineCourseData.json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setCourseCommonData(data?.CourseDetailsCommon)
  //       setCourseDetailData(data);
  //       console.log(data)
  //       const course = data?.courses?.find(
  //         (c) => generateSlug(c.courseTitle) === slug
  //       );
  //       setCourseData(course);

  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch course details:", err);
  //     });
  // }, [slug]);

  const courseData = useMemo(() => {
    if (!courseDetailData) return null;
    const course = courseDetailData?.courses?.find(
      (c) => generateSlug(c.courseTitle) === slug || generateSlug(c.slug) === slug
    );
    return course;
  }, [slug]);


  /**
 * @constant windowWidth
 * @author Vishal Lohbande
 *
 * Description:
 * - Tracks the current width of the browser window.
 * - Initializes `windowWidth` with `window.innerWidth`.
 * - Uses `useEffect` to listen for window resize events and update the state accordingly.
 * - Cleans up the event listener on component unmount.
 *
 * Usage:
 * - Useful for implementing responsive designs based on screen width.
 *
 * Notes:
 * - Ensure this code runs only on the client-side, as `window` is undefined on the server.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);

    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /**
   * @function handlePopup
   * @author Vishal Lohbande
   *
   * Description:
   * - Toggles the `popupFlag` state to show or hide the popup.
   * - When opening the popup (`popupFlag` was false), it resets the `name` state to an empty string and clears any error state.
   *
   * Usage:
   * - Used as a handler to open or close a popup/modal and reset certain form states on open.
   */
  const popupFlag = useSelector((state) => state.data.popupFlag);
  const handlePopup = () => {
    setError(false)
    dispatch(setPopUpFlag(!popupFlag));


    if (popupFlag === false) {
      setName('')
      setError(false)
      setNumber('')
    }
  }

  /**
* @function handleName
* @author Vishal Lohbande
*
* Description:
* - Updates the `name` state with the current value from the input field.
*
* Parameters:
* - `e` (Event): The event object from the input's `onChange` event.
*
* Usage:
* - Used as an event handler for controlled input to update the `name` state dynamically.
*/
  const handleName = (e) => {
    setName(e.target.value)

  }

  /**
* @function handleNumber
* @author Vishal Lohbande
*
* Description:
* - Updates the `number` state with the current value from the input field.
* - If the input length reaches exactly 10 and the `isValidNumber` flag is true, resets `isValidNumber` to false.
*
* Parameters:
* - `e` (Event): The event object from the input's `onChange` event.
*
* Usage:
* - Used as an event handler for controlled input to update the `number` state and manage validation status.
*/
  const handleNumber = (e) => {
    setNumber(e.target.value)
    if (e.target.value.length === 10 && isValidNumber) {
      setIsValidNumber(false)
    }
  }

  const [downloadFlag, setDownloadFlag] = useState(false)
  const handleClose = () => {
    console.log("close")
    setDownloadFlag(false)
  }

  var stdData = {
    name: name,
    number: number,
    course: 'JAVA',
  }

  const isValidMobile = (input) => {
    const mobileRegex = /^[6-9]\d{9}$/; // Indian mobile number pattern (10 digits, starts with 6-9)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // General email pattern

    if (mobileRegex.test(input)) {
      return true;
    } else if (emailRegex.test(input)) {
      return true;
    } else {
      return false;
    }
  };

  const formatDateTime = (dateTime) => {
    try {
      const date = new Date(dateTime);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const formattedDateSplit = date.toLocaleDateString("en-GB", options).replace(/\//g, "-").split('-');
      const formattedDate = `${formattedDateSplit[2]}-${formattedDateSplit[1]}-${formattedDateSplit[0]}`
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM";
      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${"00"}`;
      return `${formattedDate} ${formattedTime}`;
    } catch (err) {

    }

  };

  /**
     * @function handleSubmit
     * @author Vishal Lohbande
     *
     * Description:
     * - Handles form submission asynchronously.
     * - Sets success state to true initially.
     * - Prepares `stdData` object with form input values (name, number, and a fixed course value).
     * - Validates if the required fields are non-empty.
     * - Validates the mobile number/email using `isValidMobile`.
     * - If validation fails, sets appropriate error and validation flags and stops execution.
     * - Constructs a `FormData` object with `stdData` and the current date.
     * - Sends a POST request with the form data to a Google Apps Script endpoint.
     * - Handles success by resetting flags and clearing input fields.
     * - Handles errors by resetting flags and closing popup without crashing.
     *
     * Parameters:
     * - `e` (Event): Form submission event (currently unused but usually to prevent default behavior).
     *
     * Usage:
     * - Used as a submit handler to validate and send form data to backend.
     *
     * Notes:
     * - Consider calling `e.preventDefault()` to prevent default form submission.
     * - `name` state reset to `null` after submission, which might cause controlled input warnings; consider resetting to empty string `''`.
     */
  const handleSubmit = async (e) => {
    setIsSuccess(true)
    stdData = {
      name: name,
      number: number,
      course: courseData?.courseTitle,
    }

    const isInvalid = [
      stdData.name,
    ].some(field => field === null || field === '');

    if (isInvalid) {
      setError(true);
      setIsSuccess(false);
      return;
    }

    if (!isValidMobile(stdData.number)) {
      setIsSuccess(false);
      setError(true)
      setIsValidNumber(true)
      return;
    } else {
      setIsValidNumber(false)
    }


    const formData = new FormData();
    formData.append('date', formatDateTime(new Date().toISOString()));
    Object.keys(stdData).forEach(key => {
      formData.append(key, stdData[key]);
    });

    try {

      const response = await fetch('https://script.google.com/macros/s/AKfycbz51NSoWJfpCpVuK_geh-nNKXTcog7UKBOhPJke9xc6cadj2NlxUXz_1dRnvoYgfNPuLA/exec', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Network error or script issue');
      setIsSuccess(false);
      dispatch(setPopUpFlag(false))
      setName(null)
      setIsValidNumber(false)
      setDownloadFlag(true)
      // toast.success('You have registered Successfully', {autoClose: 2000})
    } catch (error) {
      setIsSuccess(false);
      dispatch(setPopUpFlag(false))
      setIsValidNumber(false)
      setDownloadFlag(false)
    }
  };

  return (
    <div className='C2wOfflineCoursePage_ctn'>

      <div className='C2wOfflineCourses_ctn_scroller' id={'C2wOfflineCourses_ctn_scroller_id'}>
        <C2wNavbar />
        <C2wCourseDetailsCourseDescription courseData={{
          type: courseData?.type,
          fees: courseData?.fees,
          gst: courseData?.gst,
          courseTitle: courseData?.courseTitle,
          courseSubTitle: courseData?.courseSubTitle,
          courseTitleMode: courseData?.courseTitleMode,
          admissionDurationInfo: courseData?.admissionDurationInfo,
          courseDescBg: courseData?.courseDescBg,
        }}
          handlePopup={handlePopup}
        />
        <C2wCourseAnimationBar
          courseData={{
            type: courseData?.type,
            fees: courseData?.fees,
            gst: courseData?.gst,
            courseTitle: courseData?.courseTitle,
            courseSubTitle: courseData?.courseSubTitle,
            admissionDurationInfo: courseData?.admissionDurationInfo,
          }}
          handlePopup={handlePopup}
        />
        <C2wCompleteSyllabus type={'Offline'} courseData={courseData?.courseSyallabusComponentData} />
        {/* <C2wToolChain type={0} /> */}
        {/* <C2wTopAiTools /> */}
        {courseData?.courseTitle === "Python Data Science GenAI with IoT & Robotics" && <C2wOfflineCourseProject handlePopup={handlePopup} />}
        <C2wSuperxWinners />
        <C2wScrollerFramer />
        {/* <C2wQuizeethon /> */}
        <C2wCourseHabits courseData={courseData?.habitsComponentData} />
        <C2wCourseAnalytics type={'Offline'} />
        <C2wReviews courseData={courseDetailData?.CourseDetailsCommon.reviewsComponentData} />
        <C2wOfflineCertificates courseTitle={courseData?.courseTitle} />
        <C2wRules courseData={{
          fees: courseData?.fees,
          gst: courseData?.gst,
          courseHours: courseData?.courseHours,
          courseValidity: courseData?.courseValidity,
          type: courseData?.type
        }}
        />
        <div className="ADfooter__container">
          <Footer />
        </div>
      </div>
      {popupFlag &&
        <div className='C2wDownaloadApp_popup'>
          <C2wAppRegisterInfoPopUp
            error={error}
            handleName={handleName}
            handleNumber={handleNumber}
            setPopUpFlag={setPopUpFlag}
            handleSubmit={handleSubmit}
            isSuccess={isSuccess}
            isValidNumber={isValidNumber}
            course={courseData?.courseTitle}
          />
        </div>
      }

      {downloadFlag &&
        <div className='C2wDownaloadApp_popup'>
          <C2wAppDownloadPopUp handleClose={handleClose} />
        </div>
      }
    </div>
  )
}

export default C2wOfflineCoursePage
